import imagesLoaded from "imagesloaded";
import Masonry from "masonry-layout";

const Timeline = (function () {
  function isScrolledIntoView(elem: HTMLElement) {
    const document = $(window);
    const element = $(elem);

    if (document && element) {
      const docViewBottom = document.scrollTop()! + document.height()!;
      const elemTop = element?.offset()?.top;
      if (elemTop) {
        return elemTop + 50 < docViewBottom;
      }
    }

    return true;
  }

  function init() {
    $(function () {
      if ($(".timeline-block").length > 0) {
        $(".timeline-block").imagesLoaded(() => {
          $(window).on("scroll resize", () => {
            $(".timeline-block__item").each(function () {
              if (isScrolledIntoView(this) === true)
                $(this).addClass("timeline-block__item--show");
            });
          });
          $(window).trigger("scroll");
        });

        const timelineBlock = document.querySelector(".timeline-block")!;

        const grid = new Masonry(timelineBlock, {
          itemSelector: ".timeline-block__item",
          columnWidth: ".timeline-block__sizer",
          percentPosition: true,
        });

        const imgLoad = imagesLoaded(timelineBlock);

        const items = document.querySelectorAll<HTMLElement>(
          ".timeline-block__item",
        );
        if (items.length > 1) {
          const firstItemHeight = items[0].offsetHeight;
          items[1].style.paddingTop = `${firstItemHeight / 2}px`;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        grid?.on?.("layoutComplete", function (laidOutItems: any[]) {
          laidOutItems.forEach((item) => {
            const isLeft =
              item.element &&
              item.element.style &&
              item.element.style.left === "0%";

            item.element.classList.remove(
              "timeline-block__item--right",
              "timeline-block__item--left",
            );

            item.element.classList.add("timeline-block__item--finished");

            if (isLeft)
              item.element.classList.add("timeline-block__item--left");
            else item.element.classList.add("timeline-block__item--right");
          });
        });

        imgLoad.on("always", function () {
          if (grid && grid.layout) {
            grid.layout();
          }
        });

        // layout Masonry after each image loads
        imgLoad.on("progress", function () {
          if (grid && grid.layout) {
            grid.layout();
          }
        });
      }
    });
  }

  return {
    init,
  };
})();

export default Timeline;
